<tlk-modal-header>
    {{ dialogInput.titleTranslationKey | translate }}
</tlk-modal-header>

<tlk-modal-content>
    <div class="dialog-content">
        <div class="info-icon" [ngStyle]="{ 'background-image': 'url(' + iconSrc + ')' }"></div>
        <div class="dialog-message" [innerHTML]="dialogInput.contentTranslationKey | translate">
        </div>
    </div>
</tlk-modal-content>

<tlk-modal-footer>
    <ng-container ngProjectAs="[left-buttons]">
        <tlk-checkbox *ngIf="isDontShowAgainVisible" [(ngModel)]="dontShowAgain">
            {{ 'Popup.DontShowAgainTitle' | translate }}
        </tlk-checkbox>
    </ng-container>
    <ng-container ngProjectAs="[right-buttons]">
        <button *ngIf="showCancelButton" tlkButton variant="secondary" size="l" style="min-width: 120px" (click)="close(popUpActions.Cancel)">
            {{ 'Popup.Cancel' | translate }}
        </button>
        <button tlkButton variant="primary" size="l" class="ok-button" style="min-width: 120px" (click)="close(popUpActions.Ok)">
            {{ 'Popup.OK' | translate }}
        </button>
    </ng-container>
</tlk-modal-footer>
